import { render, staticRenderFns } from "./DonationAdmin.vue?vue&type=template&id=0bcfb921&"
import script from "./DonationAdmin.vue?vue&type=script&lang=js&"
export * from "./DonationAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports